import { Job } from '../core-data-model/Job.model';
import { Person } from '../core-data-model/Person.model';
import { StringUtilities } from '../core-utilities/String.utility';

export class AssessmentDetail {
    person: Person;
    job: Job;
    autoSendBehavioralReport: boolean;

    constructor(person: Person, job: Job, autoSendBehavioralReport = false) {
        this.person = person;
        this.job = job;
        this.autoSendBehavioralReport = autoSendBehavioralReport;
    }

    isValid() {
        return (
            this.person.firstName &&
            this.person.lastName &&
            this.person.email &&
            StringUtilities.rawEmailValidation(this.person.email) &&
            this.person.folder
        );
    }
}
